// extracted by mini-css-extract-plugin
export default {"catalogByService":"c-l_fy"};